import React, {useEffect} from "react";
import styles from "./ModalC.module.scss";
import {Modal} from "react-bootstrap";
import {useModal} from "../../context/ModalContext";
import Button from "../Button/Button";
import {useResponseStatus} from "../../context/ResponseStatusContext";
import LazyImage from "../LazyImage/LazyImage";

const ModalC: React.FC = () => {
    const {showModalC, closeModals} = useModal();
    const {responseStatus, formType} = useResponseStatus();

    // useEffect(() => {
    //     console.log("showModalC changed: ", showModalC);
    // }, [showModalC]);

    const renderContent = () => {
        if (responseStatus) {
            switch (formType) {
                case 'feedback':
                    return {
                        title: "Сообщение успешно отправлено",
                        message: "Наш специалист свяжется с вами в ближайшее время.",
                        imgSrc: "./assets/images/general/success.png",
                        imgAlt: "Успех"
                    };
                case 'payment':
                    return {
                        title: "Оплата прошла успешно",
                        message: "Инструкция по активации вашего тарифного плана отправлена на указанный Вами электронный адрес. Спасибо, что выбираете нас!",
                        imgSrc: "./assets/images/general/success.png",
                        imgAlt: "Успех"
                    };
                default:
                    return {
                        title: "Здравствуйте!",
                        message: "Спасибо за ваше сообщение. Мы свяжемся с вами в ближайшее время.",
                        imgSrc: "./assets/images/general/success.png",
                        imgAlt: "Успех"
                    };
            }
        } else {
            return {
                title: "Ошибка!",
                message: "Возможно, это был временный сбой - просто попробуйте снова.",
                imgSrc: "./assets/images/general/failed.png",
                imgAlt: "Провал"
            };
        }
    };

    const {title, message, imgSrc, imgAlt} = renderContent();

    return (
        <Modal show={showModalC} onHide={closeModals} className={styles.modalC} centered>
            <Modal.Header className={styles.modalCHeader} closeButton/>
            <Modal.Body className={styles.modalCBody}>
                <LazyImage src={imgSrc} alt={imgAlt} className={styles.modalCIcon}/>
                <Modal.Title>{title}</Modal.Title>
                <p>{message}</p>
            </Modal.Body>
            <Modal.Footer className={styles.modalCFooter}>
                <Button classButton="redButton" onClick={closeModals}>
                    {responseStatus ? "Вернуться на страницу" : "Попробовать снова"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalC;
